import {MessageSeverityType} from '@toolify/client/src/modules/notifications/enum/MessageSeverityType'

// Pinned cards sit at the bottom of the stack: persistent results (1), then progress (2) right at the screen edge
export function getLocalMessagePinRank(message: {severity: MessageSeverityType}): number {
  return message.severity === MessageSeverityType.Progress ? 2 : 1
}
